<!-- src/layouts/privateLayout.vue -->
<template>
  <main class="page">
    <router-view />
  </main>
</template>

<script setup></script>

<style scoped>
body {
  padding-bottom: 60px;
}
.page {
  background-color: #f5f7fa;
}

/* Em dispositivos com safe-area (como iPhones com notch) */
@supports(padding: max(0px)) {
  body {
    padding-bottom: max(60px, env(safe-area-inset-bottom));
  }
}
</style>
